var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "@/interface/IVueDialog";
import Uploader from "./uploaderText.vue";
import InputUploader from "@/common/components/InputUploader.vue";
import AccoutCheckService from '@/api/AccoutCheckService';
var EditDialog = (function (_super) {
    __extends(EditDialog, _super);
    function EditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.document_pic = [];
        _this.order_id = '';
        return _this;
    }
    EditDialog.prototype.mounted = function () {
    };
    EditDialog.prototype.created = function () {
        this.service = AccoutCheckService.getInstance();
    };
    EditDialog.prototype.save = function () {
        var _this = this;
        console.log(this.document_pic);
        var order_document = JSON.stringify(this.document_pic.map(function (item) { return ({ url: item.url, text: item.text }); }));
        var params = {
            order_document: order_document,
            order_id: this.order_id
        };
        this.service.updateInvoice(params).then(function (res) {
            console.log(res.data, 7777);
            if (res.data.code == 0) {
                _this.$message.success('保存成功');
                _this.$closeDialog();
                _this.$emit('editClient:ok');
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    EditDialog.prototype.close = function () {
        this.$closeDialog();
    };
    EditDialog = __decorate([
        Component({
            components: {
                uploader: Uploader,
                InputUploader: InputUploader
            }
        })
    ], EditDialog);
    return EditDialog;
}(VueDialog));
export default EditDialog;
